import React from "react"

import Layout from "../components/layout"
import SEO from "../components/seo"
import Card from "../components/card"
import EncloseFloats from "../components/enclose-floats"
import { EntryTitle, EntryHeader } from "../components/entry"

const WebsiteFeedback = () => {
  return (
    <Layout>
      <SEO
        title="Website Feedback"
        description="If you have any suggestions, comments, or other feedback on the Vancouver-Anime.com website feel free to submit them here."
      />
      <Card variant="primary">
        <EncloseFloats>
          <EntryHeader>
            <EntryTitle>Website Feedback</EntryTitle>
          </EntryHeader>
          <p>
            If you have any suggestions, comments, or other feedback on the
            Vancouver-Anime.com website please send an email to{" "}
            <a href="mailto:vanime@danf.ca">vanime@danf.ca</a>.
          </p>
        </EncloseFloats>
      </Card>
    </Layout>
  )
}

export default WebsiteFeedback
